"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/Pending");
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageLoad: true
        };
        return _this;
    }
    Home.prototype.componentDidMount = function () {
        this.ensureDataFetched();
    };
    Home.prototype.ensureDataFetched = function () {
        this.props.requestFunction(this.state.pageLoad);
        this.state = {
            pageLoad: false
        };
    };
    Home.prototype.render = function () {
        return (React.createElement("div", { style: { paddingLeft: 'unset' } },
            React.createElement("h4", { className: "mb-3", style: { fontWeight: 'bold' } }, "Pending Application"),
            this.props.isLoading && this.renderApplication(this.props.response),
            React.createElement("hr", null),
            React.createElement("h4", { className: "mb-3", style: { marginTop: '10px', fontWeight: 'bold' } }, "Pending Service"),
            this.props.isLoading && this.renderService(this.props.response)));
    };
    Home.prototype.renderApplication = function (data) {
        return (React.createElement(React.Fragment, null,
            React.createElement("table", { className: 'table table-bordered' },
                React.createElement("thead", null,
                    React.createElement("tr", { style: { background: "rgba(9, 132, 227, 1)", color: "#fff", fontSize: '10pt' } },
                        React.createElement("th", null, "Application UUID"),
                        React.createElement("th", null, "Application Name"),
                        React.createElement("th", null, "Application ID"),
                        React.createElement("th", null, "Email"),
                        React.createElement("th", null, "Status"),
                        React.createElement("th", null, "Created By"),
                        React.createElement("th", null, "Created On"))),
                React.createElement("tbody", null, (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.app_list.map(function (item) {
                    return React.createElement("tr", { key: item.app_uuid, className: "table-tbody" },
                        React.createElement("td", null, item.app_uuid),
                        React.createElement("td", null, item.app_name),
                        React.createElement("td", null, item.app_id),
                        React.createElement("td", null, item.email),
                        React.createElement("td", null, item.active_status),
                        React.createElement("td", null, item.created_by),
                        React.createElement("td", null, item.created_on));
                })))));
    };
    Home.prototype.renderService = function (data) {
        return (React.createElement(React.Fragment, null,
            React.createElement("table", { className: 'table table-bordered' },
                React.createElement("thead", null,
                    React.createElement("tr", { style: { background: "rgba(9, 132, 227, 1)", color: "#fff", fontSize: '10pt' } },
                        React.createElement("th", null, "Application Name"),
                        React.createElement("th", null, "Service ID"),
                        React.createElement("th", null, "Service Name"),
                        React.createElement("th", null, "Created By"),
                        React.createElement("th", null, "Created On"),
                        React.createElement("th", null, "Status"))),
                React.createElement("tbody", null, (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.service_list.map(function (item) {
                    return React.createElement("tr", { key: item.service_id, className: "table-tbody" },
                        React.createElement("td", null, item.app_name),
                        React.createElement("td", null, item.service_id),
                        React.createElement("td", null, item.service_name),
                        React.createElement("td", null, item.created_by),
                        React.createElement("td", null, item.created_on),
                        React.createElement("td", null, item.link_active_status));
                })))));
    };
    return Home;
}(React.Component));
exports.default = react_redux_1.connect(function (state) { return state.pending; }, Stores.actionCreators)(Home);
//# sourceMappingURL=Home.js.map